import { render, staticRenderFns } from "./upMultipleSelect.vue?vue&type=template&id=20ab7dc0&"
import script from "./upMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./upMultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./upMultipleSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports